var rich_content_viewer_default = {
  "fontElementMap": "Lad1k",
  "wrapper": "TdSDS",
  "pluginContainerMobile": "_3ye9i",
  "viewer": "H34U1",
  "android": "_9vh1U",
  "rootedTraversedContent": "fjDxW",
  "atomic": "ndv20",
  "toolbar": "z04-A",
  "block": "-LlQk"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
